import { GzFormFieldWebComponent } from './component/GzFormFieldWebComponent';
import { WEB_COMPONENT_GZ_FORM_FIELD, WEB_COMPONENT_GZ_FORM_FIELD_TOGGLEABLE } from '../../../webcomponents.constants';
import { GzFormFieldToggleableWebComponent } from './component/GzFormFieldToggleableWebComponent';

export { GzFormFieldWebComponent, GzFormFieldToggleableWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_FORM_FIELD, GzFormFieldWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_FORM_FIELD_TOGGLEABLE, GzFormFieldToggleableWebComponent);
